import "./POIRegionEditFilter.scss";
import FilterTypeMenu from "@/components/Common/FilterTypeMenu/FilterTypeMenu.vue";

const defaultFilterValue = {
  categories: [],
  regions: [],
  seasonFeature: ""
};

export default {
  name: "POIRegionEditFilter",
  components: { FilterTypeMenu },
  props: ["value", "categories", "regions", "summerFeature", "winterFeature"],
  data: () => ({
    dialog: false,
    localValue: { ...defaultFilterValue }
  }),
  computed: {
    selectedCategories() {
      return this.localValue?.categories || [];
    },
    selectedRegions() {
      return this.localValue?.regions || [];
    },
    seasonItems() {
      const items = [{ id: "", title: "Alle" }];
      if (this.summerFeature?._id) {
        items.push({
          id: this.summerFeature._id,
          title: this.summerFeature.title
        });
      }
      if (this.winterFeature?._id) {
        items.push({
          id: this.winterFeature._id,
          title: this.winterFeature.title
        });
      }
      return items;
    },
    selectedSeason() {
      return this.localValue?.seasonFeature
        ? [this.localValue.seasonFeature]
        : [];
    }
  },
  watch: {
    value: {
      immediate: true,
      deep: true,
      handler(value) {
        this.localValue = this.normalizeFilter(value);
      }
    }
  },
  methods: {
    normalizeFilter(value) {
      return {
        categories: [...(value?.categories ?? [])],
        regions: [...(value?.regions ?? [])],
        seasonFeature: value?.seasonFeature ?? ""
      };
    },
    openDialog() {
      this.localValue = this.normalizeFilter(this.value);
      this.dialog = true;
    },
    toggleCategory(category) {
      const id = category?._id;
      if (!id) return;
      if (this.localValue.categories.includes(id)) {
        this.localValue.categories = this.localValue.categories.filter(
          catId => catId !== id
        );
      } else {
        this.localValue.categories = [...this.localValue.categories, id];
      }
    },
    toggleRegion(region) {
      const id = region?._id;
      if (!id) return;
      if (this.localValue.regions.includes(id)) {
        this.localValue.regions = this.localValue.regions.filter(
          regionId => regionId !== id
        );
      } else {
        this.localValue.regions = [...this.localValue.regions, id];
      }
    },
    setSeason(item) {
      const id = item?.id ?? "";
      this.localValue.seasonFeature =
        this.localValue.seasonFeature === id ? "" : id;
    },
    applyFilter() {
      const nextFilter = this.normalizeFilter(this.localValue);
      this.$emit("input", nextFilter);
      this.$emit("apply", nextFilter);
      this.dialog = false;
    },
    resetFilter() {
      const resetValue = this.normalizeFilter(defaultFilterValue);
      this.localValue = resetValue;
      this.$emit("input", resetValue);
      this.$emit("reset", resetValue);
      this.dialog = false;
    }
  }
};
